<template>
    <c-dialog ref="dialog" width="500" @resolve="submitHandle">
        <c-form ref="form" vertical unit-width="100%">
            <c-input type="hidden" name="user_ids"></c-input>
            <c-form-item label="已选用户">
                <c-input type="textarea" name="user_realnames" disabled></c-input>
            </c-form-item>
            <c-form-item label="星级" required>
                <c-select name="star_level" :options="starOptions"></c-select>
            </c-form-item>
            <c-form-item label="备注">
                <c-input type="textarea" name="remark" maxlength="500" placeholder="请输入备注"></c-input>
            </c-form-item>
        </c-form>
    </c-dialog>
</template>

<script>export default {
    data() {
        return {
            starOptions: [
                { name: '1星', value: 1 },
                { name: '2星', value: 2 },
                { name: '3星', value: 3 },
            ]
        }
    },
    methods: {
        open(data) {
            this.$refs.form.clear();
            if (data) {
                this.$refs.form.set({
                    user_ids: data.user_ids,
                    user_realnames: data.user_realnames
                });
            }
            this.$refs.dialog.open({
                title: '批量设置工程师星级'
            });
        },

        submitHandle(stop, next) {
            stop();
            this.$refs.form.submit({
                url: '/sys_user/update_star_level',
                rule: {
                    user_ids: '请至少选择一个用户',
                    star_level: '请选择星级'
                },
                success: (data, res) => {
                    next();
                    this.$message({
                        message: '设置成功',
                        type: 'success'
                    });
                    this.$emit('resolve');
                }
            });
        }
    }
}
</script>

<style lang="stylus" scoped></style>